'use client';

import { useCatalogContext } from '@dealerportal/catalog-ui/Contexts/CatalogContext';
import type { KeyVal, ProductInformation } from '@dealerportal/common';
import type { Dispatch, SetStateAction } from 'react';
import { PricingSection } from './PricingSection';
import { SizeSelect } from './SizeSelect';
import { SwatchCollection } from './SwatchCollection';

type ProductDetailsContentProps = {
  productInfo: ProductInformation;
  specs: KeyVal[];
  setSpecs: Dispatch<SetStateAction<KeyVal[]>>;
};

export const ProductDetailsContent = ({
  productInfo,
  specs,
  setSpecs,
}: ProductDetailsContentProps) => {
  const { settings } = useCatalogContext();
  return (
    <>
      {productInfo.description && (
        <p data-testid="product-description" className="!ui-text-base">
          {productInfo.description}
        </p>
      )}

      {productInfo.additionalMessage && (
        <div className="!ui-mt-3">
          <div className="ui-mt-2 ui-mb-4 ui-flex ui-items-center ui-gap-2 ui-text-sm">
            {productInfo.additionalMessage}
          </div>
        </div>
      )}

      <div className="pdp__swatches">
        <SwatchCollection
          swatches={productInfo.swatches}
          activeSwatch={productInfo.UPID}
        />
      </div>

      <div className="pdp__size-select">
        <SizeSelect productInfo={productInfo} setSpecs={setSpecs} />
      </div>

      {!settings?.hidePricing && (
        <div className="pdp__price">
          <PricingSection
            brandName={productInfo.brandName}
            unitPrice={productInfo.unitPrice}
            pricePerBox={productInfo.pricePerBox}
            priceDescription={productInfo.priceDescription}
            pricingMessage={productInfo.pricingMessage}
            additionalMessage={productInfo.additionalMessage}
          />
        </div>
      )}
    </>
  );
};
